import { Component} from '@angular/core';


@Component({
  selector: 'app-optical-header',
  templateUrl: './optical-header.component.html',
  styleUrls: ['./optical-header.component.scss']
})
export class OpticalHeaderComponent {

}
